import eyespyHero from '../../../media/software/eyespy/glasses.png';
import eyespy1 from '../../../media/software/eyespy/A935C07B-FCC0-48E9-AB51-CE5AD644C4AB_1_105_c.jpeg';
import eyespy2 from '../../../media/software/eyespy/E60D0B5E-1B77-4F11-9B44-F923DDA6B7DC_1_105_c.jpeg';
import eyespy3 from '../../../media/software/eyespy/F1A56D94-5234-4FF2-88EA-91ABC6657297_1_105_c.jpeg';
import eyespy4 from '../../../media/software/eyespy/608BC7A6-CEF7-402F-8B0D-FCC4A32B9A1B_1_105_c.jpeg';
import eyespyVideo1 from '../../../media/software/eyespy/EyeSpy.mp4';
import eyespyVideo2 from '../../../media/software/eyespy/EyeSpy Demo2.mp4';
import eyespyVideo3 from '../../../media/software/eyespy/ScreenRecording_04-08-2025 23-09-10_1.mp4';

const eyeSpyData = {
  name: "EyeSpy",
  category: "Agentic AI",
  tagline: "Real-time facial recognition software for smart glasses",
  duration: "Spring 2025",
  heroImage: eyespyHero,

  description: "EyeSpy is facial recognition software for Meta Ray Ban glasses and photo uploads. I built an iOS application in Swift with API caching for real-time identification results, including biographical details and location data. AWS Rekognition detects faces and filters those already stored in the database. FaceCheckID returns matches and source links; LLM agents use Firecrawl to extract names from those sources, with consensus across multiple results determining the match. Identified names are sent to People Data Labs for background information. A multithreaded Flask backend with PostgreSQL processes identifications in parallel. I also developed EyeSpy Meets, a Google Meet integration used to demonstrate my work to MIRA.",

  highlight: "Field test: the system identified actor Adam Scott in real time during an in-person encounter viewed through the glasses.",

  techStack: [
    "Swift",
    "iOS Development",
    "AWS Rekognition",
    "FaceCheckID",
    "Firecrawl",
    "People Data Labs",
    "Flask",
    "PostgreSQL",
    "Python",
    "Multi-threading",
    "OpenAI API",
    "Meta Ray Bans",
    "API Caching",
    "Computer Vision"
  ],

  gallery: [
    { type: 'video', src: eyespyVideo1, alt: 'Uploading Adam Scott photo and viewing identification results' },
    { type: 'video', src: eyespyVideo2, alt: 'EyeSpy Meets - Real-time facial recognition during Google Meets call' },
    { type: 'video', src: eyespyVideo3, alt: 'Uploading Lucas Turano photo and viewing identification results' },
    { type: 'image', src: eyespy1, alt: 'Lucas Turano identification results with biographical information' },
    { type: 'image', src: eyespy2, alt: 'iOS app list view showing identified individuals' },
    { type: 'image', src: eyespy3, alt: 'Adam Scott identification results with biographical information' },
    { type: 'image', src: eyespy4, alt: 'Dr. Verkhivker identification results in JSON format' }
  ],
};

export default eyeSpyData;
